import { createUseStyles } from 'react-jss';
// Styles
const useTextInputStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        justifyContent: 'center',
        paddingTop: ({ label }) => label === '' || label === undefined ? '8px' : '0px',
        width: ({ fullWidth }) => (fullWidth ? '100%' : '288px')
    },
    base: {
        margin: 0,
        marginBottom: ({ hint }) => hint === '' || hint === undefined ? 20 : 0,
        padding: [12, 8],
        border: '1px solid',
        borderRadius: '5px',
        borderColor: theme.colors.grey[3],
        fontSize: ({ width }) => (width === 'xl' ? '16px' : '14px'),
        lineHeight: ({ width }) => (width === 'xl' ? '24px' : '20px'),
        width: '100%',
        '&:hover': {
            borderColor: ({ disabled }) => disabled ? '' : theme.colors.common.black
        },
        '&:focus': {
            outline: 'none!important',
            border: '2px solid',
            padding: [11, 7],
            borderColor: theme.colors.primary.main
        }
    },
    error: {
        borderBottomColor: theme.colors.error.main,
        '&:focus': {
            borderBottomColor: `${theme.colors.error.main}!important`
        }
    },
    validated: {
        borderBottomColor: theme.colors.success.main,
        '&:focus': {
            borderBottomColor: `${theme.colors.success.main}!important`
        }
    },
    label: {
        fontSize: ({ width }) => (width === 'xl' ? '16px' : '12px'),
        lineHeight: ({ width }) => (width === 'xl' ? '24px' : '16px'),
        color: theme.colors.grey[0],
        padding: [0, 4],
        backgroundColor: 'white',
        marginBottom: '-8px',
        marginLeft: '8px',
        zIndex: 1,
        width: 'fit-content',
        '&:focus': {
            color: theme.colors.primary.main
        }
    },
    hint: {
        marginTop: '4px',
        fontSize: '12px',
        lineHeight: '16px',
        color: ({ error }) => error ? theme.colors.error.main : theme.colors.grey[0]
    },
    disabled: {
        border: `1px solid ${theme.colors.grey[3]}`,
        '&::placeholder': {
            color: `${theme.colors.grey[3]}!important`
        }
    },
    inputContainer: {
        position: 'relative',
        width: '100%'
    },
    icons: {
        position: 'absolute',
        top: '13px',
        right: '8px'
    }
}));
export default useTextInputStyles;
